import React from 'react';

import { StepChain } from '@notino/react-styleguide-v20';

import { ReactFCV } from '@types';

import { StepChainWrapper } from './styled';

interface IStep {
  text: string | JSX.Element;
  isActive: boolean;
  disabled?: boolean;
  onClick?: () => void;
}

interface IPagesStepChainProps {
  steps: IStep[];
  dataTestId?: string;
}

export const PagesStepChain: ReactFCV<IPagesStepChainProps> = React.memo(({ steps, dataTestId }) => (
  <StepChainWrapper className={dataTestId}>
    <StepChain steps={steps} />
  </StepChainWrapper>
));
